export const ACCESS_TOKEN_KEY = 'access_token';
export const REFRESH_TOKEN_KEY = 'refresh_token';
export const KULLANICI_TIPI_KEY = 'kullanici_tipi';
export const AD_SOYAD_KEY = 'ad_soyad';
export const AKTIF_SITE_KEY = 'aktif_site';
export const AKTIF_DAIRE_KEY = 'aktif_daire';
export const DAIRELER_KEY = 'daireler';
export const SITELER_KEY = 'siteler';
export const PAROLA_DEGISIKLIGI_GEREKLI_KEY = 'parola_degisikligi_gerekli';

export function clearAuthStorage() {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
  localStorage.removeItem(KULLANICI_TIPI_KEY);
  localStorage.removeItem(AD_SOYAD_KEY);
  localStorage.removeItem(AKTIF_SITE_KEY);
  localStorage.removeItem(AKTIF_DAIRE_KEY);
  localStorage.removeItem(DAIRELER_KEY);
  localStorage.removeItem(SITELER_KEY);
  localStorage.removeItem(PAROLA_DEGISIKLIGI_GEREKLI_KEY);
}
